/*
 * File: Loader.tsx
 * Project: uncle-wally
 * -----
 * Last Modified: 15 Nov 2021 2:37:47 pm
 * -----
 * Copyright (c) 2021 Elegant Software Solutions All rights reserved.
 */

import { Col, Layout, Row } from 'antd';
import { InlineStylesModel } from 'models/InlineStylesModel';
import React from 'react';
import { BlockLoader } from './BlockLoader';
const { Content } = Layout;

const styles: InlineStylesModel = {
  content: {
    textAlign: 'center'
  }
};

export const Loader = (): JSX.Element => {
  return (
    <Layout style={styles.layout}>
      <Content style={styles.content}>
        <Row justify="center" align="middle" style={styles.mainRow}>
          <Col span={24}>
            <BlockLoader direction="loader loader--slideUp" />
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};
